import React, { useState, useEffect } from 'react';
import {
  Box,
  Text,
  Flex,
  useColorModeValue,
  Spinner,
  Button,
  IconButton,
} from '@chakra-ui/react';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';

const PrecatoriosPendentesSP = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  const bg = useColorModeValue('white', 'gray.800');
  const headingColor = useColorModeValue('gray.700', 'white');
  const textColor = useColorModeValue('gray.600', 'gray.300');

  return (
    <Box p={6}>
      <Flex justify="space-between" align="center" mb={6}>
        <Flex align="center">
          <IconButton
            icon={<ArrowBackIcon />}
            onClick={() => navigate('/admin/precatorios/sp/selecionadas')}
            variant="ghost"
            aria-label="Voltar"
            mr={4}
          />
          <Box>
            <Text fontSize="2xl" fontWeight="bold" color={headingColor}>
              Precatórios Pendentes - SP
            </Text>
            <Text color={textColor} mt={1}>
              Precatórios com status "Não Contatou" ou "Em Análise"
            </Text>
          </Box>
        </Flex>
      </Flex>

      {loading ? (
        <Flex justify="center" align="center" h="400px">
          <Spinner size="xl" />
        </Flex>
      ) : (
        <Box bg={bg} p={6} borderRadius="lg" borderWidth="1px">
          <Text color={textColor} textAlign="center">
            Funcionalidade em desenvolvimento
          </Text>
        </Box>
      )}
    </Box>
  );
};

export default PrecatoriosPendentesSP;